'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UISubheader from 'UIComponents/layout/UISubheader';

const ResultsSectionHeader = props => {
  const {
    className,
    headingLevel
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["className", "headingLevel"]);

  const computedClasses = classNames('p-bottom-0', className);
  return /*#__PURE__*/_jsx(UISubheader, Object.assign({}, rest, {
    className: computedClasses,
    headingLevel: headingLevel
  }));
};

ResultsSectionHeader.propTypes = {
  className: PropTypes.string,
  headingLevel: PropTypes.string
};
ResultsSectionHeader.defaultProps = {
  headingLevel: 'h4'
};
export default ResultsSectionHeader;